import { render, staticRenderFns } from "./select-input.vue?vue&type=template&id=2433c76a"
import script from "./select-input.vue?vue&type=script&lang=ts"
export * from "./select-input.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports